var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96601 0.667969C3.93935 0.667969 0.666016 3.9413 0.666016 7.96797C0.666016 11.9946 3.93935 15.268 7.96601 15.268C11.9927 15.268 15.266 11.9946 15.266 7.96797C15.266 3.9413 11.9927 0.667969 7.96601 0.667969ZM13.9993 7.96797C13.9993 11.2946 11.2927 14.0013 7.96601 14.0013C4.63935 14.0013 1.93268 11.2946 1.93268 7.96797C1.93268 4.6413 4.63935 1.93464 7.96601 1.93464C11.2927 1.93464 13.9993 4.6413 13.9993 7.96797Z",
    fill: "#17B31B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1664 5.62404C11.3853 5.83903 11.3885 6.19078 11.1735 6.40968L7.35404 10.2986C7.24958 10.4049 7.10676 10.4648 6.95768 10.4648C6.8086 10.4648 6.66578 10.4049 6.56132 10.2986L4.82521 8.53089C4.61022 8.31199 4.61339 7.96025 4.83229 7.74525C5.05119 7.53026 5.40294 7.53343 5.61793 7.75233L6.95768 9.11644L10.3808 5.63112C10.5958 5.41221 10.9475 5.40904 11.1664 5.62404Z",
    fill: "#17B31B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick2);
export default __webpack_public_path__ + "static/media/tick2.5647d65a1585ca2443b2a2646a3b5163.svg";
export { ForwardRef as ReactComponent };